import {useState} from "react";
import {
    CircularProgress,
    Chip,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select
} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: (ITEM_HEIGHT * 4.5) + ITEM_PADDING_TOP,
            width: 250
        }
    },
    MenuListProps: {
        sx: {paddingBottom: 0}
    }
};

const contentSelectGridStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.5
};

export default function ContentSelect({
  selectedContentIds,
  handleContentChange,
  availableContent,
  loading,
  filteredContent,
  disabled
}) {
    const [isContentDropdownOpen, setIsContentDropdownOpen] = useState(false);

    const handleContentSelectionChanged = (event) => {
        const contentIds = event.target.value;

        handleContentChange(contentIds);
        setIsContentDropdownOpen(false);
    };

    return (
      <FormControl fullWidth>
          <InputLabel id="content-select-label">Content</InputLabel>
          <Select
            multiple
            labelId="content-select-label"
            id="content-select"
            value={selectedContentIds}
            open={isContentDropdownOpen}
            onOpen={() => setIsContentDropdownOpen(true)}
            onClose={() => setIsContentDropdownOpen(false)}
            onChange={handleContentSelectionChanged}
            input={<OutlinedInput label="Content"/>}
            renderValue={(selected) => (
              <Grid sx={contentSelectGridStyle}>
                  {selected.map((id) => {
                      const content = availableContent.find(item => item.id === id);
                      return content ? <Chip key={id} label={content.name}/> : null;
                  })}
              </Grid>
            )}
            MenuProps={MenuProps}
            disabled={disabled}
          >
              {loading
                ? <MenuItem disabled><CircularProgress size={24}/></MenuItem>
                : filteredContent.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                      {item.name}
                  </MenuItem>
                ))
              }
          </Select>
      </FormControl>
    );
}